import React, { Component } from "react";
import Image from "../../Image";
export default class TncAditya extends Component {
  render() {
    return (
      <div className="hdfc_page">
        <h5 className="icici_headings">REFERRAL SERVICE AGREEMENT</h5>

        <h6 style={{ marginBottom: 20 }}>
          This Service Agreement (“Agreement”) is made at_____on_______ day
          of_______ , 2022___
        </h6>
        <p>BY AND BETWEEN</p>
        <p>
          Aditya Birla Sun Life Pension Management Limited, a company
          incorporated under the Companies Act, 2013 and having its registered
          office at One Indiabulls Centre Tower 1, 16th Floor, Jupiter Mill
          Compound, 841, Senapati Bapat Marg, Elphinstone Road, Mumbai- 400013
          (hereinafter referred to as “ABSLPML” which expression shall unless
          repugnant to the context or meaning thereof include its successors,
          legal representative (s), executors and permitted assigns) of the
          First Part,AND_______________________________________________ , an
          individual/ sole proprietorship/ partnership firm/ a company / trust /
          society or any other entity duly formed under the laws of India,
          having its principal/ registered office
          at______________________________ (hereinafter referred to as the
          “Referral Agent”, which expression shall unless repugnant to the
          context or meaning there of include its legal heirs, successors, legal
          representative(s), executors and permitted assigns) of the Second
          Part.
        </p>
        <p>
          ABSLPML and Referral Agent are hereinafter collectively referred to as
          “Parties” and individually also as “Party”.
        </p>

        <h5>WHEREAS: </h5>

        <p style={{ margin: 10 }}>
          I. ABSLPML has been granted a certificate of registration as a Point
          of Presence (POP) by the Pension Fund Regulatory and Development
          Authority (“Authority”) for distribution (including marketing) and
          Servicing for public at large through physical as well as online
          including accepting applications and contributions under National
          Pension System (NPS).
        </p>
        <p style={{ margin: 10 }}>
          II. The Referral Agent has adequate facilities, infrastructure,
          skilled manpower to provide referral services to ABSLPML such as to
          refer the potential NPS subscribers to ABSLPML in accordance with the
          rules, regulations, guidelines, directions, notifications, circulars,
          code of conduct and their amendments issued by the Authority from time
          to time.
        </p>
        <p style={{ margin: 10 }}>
          III. ABSLPML has agreed to avail the services of the Referral Agent on
          terms and conditions as mutually agreed under this Agreement. Now,
          therefore, in consideration of the mutual understanding as set forth
          in this Agreement the Parties hereto have agreed to the following
          terms and conditions:
        </p>
        <p style={{ margin: 10 }}>
          1. The Referral Agent shall refer the potential NPS subscribers to
          ABSLPML under this Agreement. The Referral Agent will assist ABSLPML
          in completing Know Your Customer (KYC) verification / client due
          diligence and proper investigation regarding financial credibility of
          the potential subscribers. The Referral Agent shall also provide
          additional information which ABSLPML deem necessary for enrolment of
          referred subscribers.
        </p>
        <p style={{ margin: 10 }}>
          2. ABSLPML, at its sole discretion, shall have absolute right to
          accept or reject the potential subscriber referred by the Referral
          Agent and the decision of ABSLPML in this regard shall be final and
          binding on the Referral Agent.
        </p>
        <p style={{ margin: 10 }}>
          3. The Referral Agent shall not enter into any private agreement with
          the potential subscribers. All agreements are to be entered by the
          potential subscribers directly with ABSLPML and the Referral Agent
          shall have no privity of contract in any agreements executed by and
          between ABSLPML and potential subscribers.
        </p>
        <p style={{ margin: 10 }}>
          4. The Referral Agent shall strictly follow the code of the conduct
          laid down by PFRDA and ABSLPML while soliciting/referring the
          potential subscribers and shall not give assurance of any kind of
          profit/ return on any of the schemes/funds of NPS to potential
          subscribers. The Referral Agent is prohibited from indulging in any
          unfair conduct, i.e. an act or omission that significantly impairs, or
          likely to significantly impair the ability of a potential subscriber
          to make an informed transactional decision and includes conduct that
          is misleading or abusive, while dealing with potential subscribers.
        </p>
        <p style={{ margin: 10 }}>
          5. The Referral Agent shall not take any payment either in cash or
          otherwise in his/her/its name from the potential subscribers referred
          to ABSLPML.
        </p>
        <p style={{ margin: 10 }}>
          6. The Referral Agent agrees not to represent him / her / itself in
          any capacity other than one referring potential subscribers to
          ABSLPML. Further, the Referral Agent shall not undertake any other
          activity for or on behalf of ABSLPML during the existence of this
          Agreement and shall not act in any manner what so ever for or on
          behalf of ABSLPML after the expiry/ termination of this Agreement
          unless expressly agreed by the Parties.
        </p>
        <p style={{ margin: 10 }}>
          7. The Referral Agent shall abide by the service standards provided
          under the regulations and guidelines issued by Authority in relation
          to National Pension System, for providing the functions relating to
          registration of subscribers, undertaking Know Your Customer (KYC)
          verification, receiving contributions and instructions from
          subscribers and transmission of the same to designated NPS
          intermediaries.
        </p>
        <p style={{ margin: 10 }}>
          8. This Agreement shall be come into force on the Effective Date and
          shall remain valid for a period of 3 (three) years from the Effective
          Date provided that the Agreement shall automatically renew for 3
          (three) years on mutually agreed terms unless either Party notifies
          the other of its intention not to renew at least 30 days prior to
          expiry of initial term or renewed period, as the case may be, or
          unless this Agreement is terminated by the Parties pursuant to any
          provision of this Agreement. This Agreement may be terminated by the
          Parties by giving 30 days’ notice to other Party in writing. Neither
          party is required to give any reason for termination. However, in case
          of breach of any terms and conditions of this Agreement, ABSLPML shall
          terminate this Agreement with immediate effect.
        </p>
        <p style={{ padding: "10px 10px 10px 0px" }}>
          9. The Referral Agent shall:
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          (a) Comply with the rules, regulations and guidelines issued by
          Authority in relation to National Pension System and relevant laws and
          guidelines issued by other statutory authorities;
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          (b) Abide by code of conduct and operational instructions/ directives
          issued by Authority from time to time and informed by ABSLPML and
          other laws in force;
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          (c) Keep and maintain the books and documents related to services;
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          (d) Comply with the Know Your Customer requirements specified or laid
          down by the Authority for National Pension System;
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          (e) The Referral Agent undertakes that it shall keep ABSLPML’s data
          identifiable and maintain confidential together with other information
          including but not limited to any documents, records, subscriber’s
          data/information, investment etc. in order to comply with the
          confidentiality provisions herein contained.
        </p>

        <p style={{ padding: "10px 10px 10px 0px" }}>
          10. General Obligations: The Referral Agent shall assist ABSLPML to --
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          (a) Provide subscriber registration forms to the applicant or
          prospective applicant for registration in National Pension System;
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          ((b) Receive subscriber registration form in Authority’s prescribed
          format duly filled and signed by the subscriber along with the
          necessary documentation;
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          (c) Ensure that prescribed Know Your Customer documents have been
          attached with the Subscriber registration form;
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          (d) Ensure that the subscriber registration form submitted by the
          applicant is complete in all respects;
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          (e) Ensure that contribution is collected only by means of
          cheque/demand draft drawn in favour of &quot; POP Aditya Birla Sun
          Life Pension Management Limited Collection Account – NPS Trust &quot;.
          Collection of National Pension System contributions by way of cash is
          not permitted by the Referral Agent;
        </p>
        <p style={{ margin: 10 }}>
          11. The Referral Agent shall not assign, delegate or transfer any
          rights, duties or obligations hereunder or interests herein without
          prior written consent of ABSLPML and any attempted assignment shall be
          null and void.
        </p>
        <p style={{ margin: 10 }}>
          12. The Referral Agent agrees not to represent itself in any capacity
          other than referral agent of ABSLPML. Further it shall not undertake
          any other activity for or on behalf of ABSLPML during the existence of
          this Agreement and shall not act in any manner whatsoever for or on
          behalf of ABSLPML after the expiry/ termination of this Agreement
          unless expressly agreed by the Parties.
        </p>

        <p style={{ margin: 10 }}>
          13. The Referral Agent undertakes to ensure that its employees and
          agents, if any, shall act in strict compliance with this Agreement and
          all applicable laws and shall ensure strict conformity to regulations,
          directions guidelines, notifications, circulars and code of conduct
          and their amendments from time to time issued by the Authority.
        </p>
        <p style={{ margin: 10 }}>
          14. Subject to the provisions made by the Authority, the Parties agree
          that ABSLPML shall pay the consideration to the Referral Agent for
          providing services agreed under the Agreement in accordance with the
          regulations and guidelines issued by Authority in relation to National
          Pension System. All payments shall be subject to statutory deductions
          and other laws applicable from time to time. ABSLPML may, in its sole
          discretion, revise the fees, charges or deposits specified in
          Schedule-1 from time to time and the same will be applicable from the
          date mentioned in the revised Schedule-1 and such revised Schedule-1
          will be deemed to be an integral part of this Agreement.
        </p>
        <p style={{ margin: 10 }}>
          15. This Agreement constitutes the entire agreement between the
          Parties with respect to the subject matter hereof and supersedes all
          prior written agreements, understandings and negotiations, both
          written and oral, between the Parties with respect to the subject
          matter of this Agreement.
        </p>
        <p style={{ margin: 10 }}>
          16. The Referral Agent shall bear the expense of its establishment and
          payment of salaries / remuneration etc. to its employees / agents and
          shall alone be responsible to ensure that all charges towards its
          establishment and payments / remuneration to its employees / agents
          meet the prevailing law, rules and notifications etc. as regards shop
          and establishment, minimum wages, hours of work, age of workers and
          all other requirements. ABSLPML shall in no circumstances be liable in
          any way for payment of any salary / wages or remuneration including
          PF, ESI etc. or any compensation to personnel / agents engaged by the
          Referral Agent in case of any accident, fatality or injury etc. and
          for all the above, the Referral Agent shall alone be responsible.
        </p>
        <h5 className="adtiya_headings">17. Confidential information</h5>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          17.1 It is anticipated that each party (the “Disclosing Party”) may
          disclose confidential and/or proprietary information to the other
          party (the “Recipient”).
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          17.2 None of the Parties hereto shall (except in exercise of its
          duties hereunder or where required to comply with legal obligations or
          requirements) disclose to any third party any information relating to
          the affairs of the fund or any other Party unless authorised in
          writing and shall use its best endeavours to prevent any such
          prohibited disclosures as aforesaid whether by any of its officers,
          employees or agents or by anyone else.
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          17.3 None of the Parties shall do or commit any act, matter or thing
          which would or might prejudice or bring into disrepute in any manner
          the business or reputation of any other Party or any director, or
          officer thereof.
        </p>

        <p style={{ padding: "0px 0px 5px 25px " }}>
          17.4 Notwithstanding the foregoing, nothing in this Agreement shall
          prevent any Party hereto from disclosing any information to such
          Party's shareholders, limited partners, auditors or professional
          advisers.
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          17.5 Except as required by any regulatory agency, court or other
          authority in the relevant jurisdiction no Party shall publish or
          otherwise make or pass on any information of a confidential nature
          without obtaining the prior written approval of all the other Parties
          hereto.
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          17.6 This provision shall survive the termination of this Agreement
          and shall remain in force indefinitely.
        </p>

        <p style={{ padding: "0px 0px 5px 25px " }}>
          17.7 The Recipient shall treat the information received as
          confidential, for so long as such information remains confidential
          information, any information disclosed to or obtained by it from the
          Disclosing Party, whether disclosed or obtained before or after the
          effective date of this agreement, which relates to the Disclosing
          Party and/or any of its subsidiaries, joint venture entities or
          affiliates, including, without limitation, information relating to the
          services, software, products, programs, program documentation,
          customers, potential customers, procedures, strategies or other
          business information respecting the Disclosing Party and/or any of its
          subsidiaries, joint venture entities or affiliates (“Confidential
          Information”).
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          17.8 “Confidential Information” shall not include (i) information
          which is publicly available at the time of Recipient’s receipt thereof
          from the Disclosing Party, (ii) information which, after Recipient’s
          receipt thereof from the Disclosing Party, becomes publicly available
          through no act or fault of Recipient; (iii) information which
          Recipient can show was lawfully in Recipient’s possession prior to the
          receipt thereof from the Disclosing Party; (iv) information which at
          the time it was received in good faith by Recipient from an
          independent third party was lawfully in possession of such third party
          and under no obligation of secrecy; and (v) information which is
          approved for release by the Disclosing Party without restriction.
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          17.9 In the event either party receives a subpoena or other order
          issued by a court or governmental agency, or is otherwise required by
          law to disclose Confidential Information, the party required to make
          the disclosure shall provide prompt and reasonable notice of any such
          order, subpoena or required disclosure to the other party prior to
          disclosure so that such other party has the opportunity to obtain a
          protective order or other relief. In the event a protective order or
          other relief is not obtained, the party required to make the
          disclosure will furnish only that portion of the Confidential
          Information that is legally required, in the opinion of its counsel,
          and will exercise reasonable efforts to obtain reliable assurances
          that confidential treatment will be accorded the Confidential
          Information.
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          17.10 The Recipient shall not disclose Confidential Information except
          to the directors, officers, or employees of the parties having a
          need-to-know, or to third parties having a need-to-know who are also
          subject to a written obligation of confidentiality with respect to
          such information that is similar in all material respects to the
          obligations set out herein.
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          17.11 The Recipient covenants and agrees to use the Confidential
          Information only for the purposes contemplated by the agreement and
          agrees that none of the Confidential Information shall be used in any
          way detrimental to the Disclosing Party or its customers.
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          17.12 The Recipient agrees to advise its directors, officers,
          employees and agents (if any) of its obligations hereunder and to
          ensure compliance by such persons with the terms hereof.
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          17.13 The Recipient shall indemnify and hold the Disclosing Party
          harmless from and against all losses and damages of any nature and
          kind suffered by the Disclosing Party (including legal costs and
          attorney’s fees) as a result of any breach by the Recipient of the
          terms and covenants of the terms contained in the agreement.
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          17.14 As monetary damages may be insufficient to remedy any breach of
          these confidentiality obligations, the Disclosing Party shall be
          entitled to immediate equitable relief, including injunction and
          specific performance, as remedies for any such breach. Such remedies
          shall not be the exclusive remedies for any breach but shall be in
          addition to all other remedies available at law or equity.
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          17.15 The mutual obligations under this agreement shall survive
          termination or expiration of the agreement.
        </p>
        <p style={{ margin: 10 }}>
          18. The Referral Agent shall indemnify ABSLPML and its officers,
          directors, employees, representatives, agents, respective directors,
          and assigns from and against any liability, loss, damage, claims,
          settlement, cost, expenses and penalties of any kind levied on ABSLPML
          emanating from acts/ omissions of the Referral Agent or its employees
          / agents arising from or relating to (a) contravention of any
          applicable laws, (b) breach of the terms, conditions, covenants,
          representations, undertakings, obligations or warranties of this
          Agreement; and (c) non-compliance of the directions of the Authority.
          ABSLPML reserves the right to withhold the payment due to the Referral
          Agent to the extent of such unpaid loss/ damage.
        </p>
        <p style={{ margin: 10 }}>
          19. Each Party agrees not to use the other Party’s name, logo,
          trademark, service marks or any other intellectual property right in
          any advertisement, publication, leaflet or document of any kind
          without obtaining prior written approval of such other Party.
        </p>
        <p style={{ margin: 10 }}>
          20. All notices required to be served under this Agreement shall be in
          writing and sent by registered post, to the other Party hereto at the
          addresses provided hereinbefore or any later addresses, notice of
          which having been previously given by one party to the other.
        </p>
        <p style={{ margin: 10 }}>
          21. If the whole or any part of the performance by the Parties of
          their respective obligations hereunder is prevented or delayed by
          causes, circumstances or events beyond the control of the Parties
          including delays due to floods, fires, accidents, earthquakes, riots,
          explosions, wars, hostilities, acts of government, custom barriers, or
          other causes of like character, then to the extent the Parties are
          prevented or delayed from performing their obligations hereunder by
          reason thereof despite due diligence and reasonable efforts to do so
          notwithstanding such causes, circumstances or events, the Parties
          shall be excused from performance hereunder for so long as such
          causes, circumstances or events shall continue to prevent or delay
          such performance. The occurrence of a force majeure event shall be
          communicated immediately to the other Party.
        </p>
        <p style={{ margin: 10 }}>
          22. ABSLPML and the Referral Agent agree that this Agreement is being
          entered on principal to principal basis and no relationship in the
          nature of partnership or master and servant or principal and agent
          shall emanate out of this Agreement between the Parties.
        </p>
        <p style={{ margin: 10 }}>
          23. Referral Agent accept and acknowledge that ABSLPML reserves right
          to audit the system, application, process, documents, data, and other
          records in terms of services provided by the Referral Agent on
          periodical basis as ABSLPML may deemed necessary to do so. Referral
          Agent assist and co-operate ABSLPML or its employees, auditor,
          consultant, authorized representative or the Authority in all respect
          to undertake take such audit at the premises of Referral Agent.
        </p>
        <p style={{ margin: 10 }}>
          24. Any modification(s), amendment(s) or supplement(s) to this
          Agreement shall be valid only if agreed by both the Parties, and is
          made in writing and signed by both the Parties.
        </p>
        <p style={{ margin: 10 }}>
          25. Any of the terms and conditions of this Agreement may be waived at
          any time by either Party, but no such waiver shall affect or impair
          the right of the waiving Party to require observance and performance
          of any other term or condition hereof and no waiver hereunder shall be
          considered valid unless made in writing and signed by the waiving
          Party and no such waiver, or any failure or delay on the part of the
          waiving Party to exercise any right, power or privilege hereunder
          shall be deemed a waiver of any subsequent breach of default nor shall
          any single or partial exercise of any such right, power or privilege
          preclude any further exercise thereof or the exercise of any other
          right, power or privilege.
        </p>
        <p style={{ margin: 10 }}>
          26. This Agreement may be terminated by the Parties by giving 30 days’
          notice to other Party in writing. Neither party is required to give
          any reason for termination. However in case of breach of any terms and
          conditions of this Agreement, ABSLPML shall terminate this Agreement
          with immediate effect.
        </p>
        <p style={{ margin: 10 }}>
          27. If any provision of this Agreement is agreed by the Parties or
          held to be illegal, void or unenforceable under any law that is
          applicable hereto or if any court of competent jurisdiction in a final
          decision so determines, this Agreement shall continue to remain in
          force save that such provision shall be deemed to be deleted here from
          with effect from the date of such agreement or decision or such
          earlier date as the Parties may agree.
        </p>
        <p style={{ margin: 10 }}>
          28. Any dispute or difference between the Parties hereto, arising out
          of or in connection with this Agreement shall be solved amicably by
          discussions and negotiations. Unresolved disputes or differences if
          any shall be referred to Arbitration. Arbitration shall be conducted
          by the sole arbitrator to be appointed by both the Parties. The
          arbitration proceedings shall be conducted in accordance with the
          provisions of the Arbitration and Conciliation Act, 1996. The venue of
          arbitration shall be exclusively at Mumbai. The Arbitration proceeding
          shall be conducted and recorded in English.
        </p>
        <p style={{ margin: 10 }}>
          29. This Agreement shall be governed by the laws of India. For all
          purposes in relation to this Agreement, and specifically with regard
          to clause 28 relating to Arbitration, the Courts at Mumbai alone shall
          have exclusive jurisdiction. No other Court shall have jurisdiction to
          deal with any dispute or any matter between the Parties arising out of
          this Agreement.
        </p>
        <p style={{ margin: 10 }}>
          IN WITNESS WHEREOF, the parties hereto have set their signatures /
          seal in presence of their respective witnesses on the day, month and
          year mentioned above.
        </p>
        <div style={{ padding: "0px 0px 10px 35px " }}>
          <p>
            Signed and delivered for and on behalf of Aditya Birla Sun Life
            Pension Management Limited By
          </p>
          <p>Signature</p>
          <span>__________________________</span>

          <p>in the presence of the witnesses:</p>
          <p>1. Name and address of witness</p>
          <span>__________________________</span>
          <span>__________________________</span>
          <span>__________________________</span>
          <p>Signature</p>

          <p>2. Name and address of witness</p>
          <span>__________________________</span>
          <span>__________________________</span>
          <span>__________________________</span>
          <p>Signature</p>
        </div>
        <div style={{ padding: "0px 0px 10px 35px " }}>
          <p>Signed and delivered for and on behalf of Referral Agent By</p>
          <p>Signature</p>
          <span>__________________________</span>

          <p>in the presence of the witnesses:</p>
          <p>1. Name and address of witness</p>
          <span>__________________________</span>
          <span>__________________________</span>
          <span>__________________________</span>
          <p>Signature</p>

          <p>2. Name and address of witness</p>
          <span>__________________________</span>
          <span>__________________________</span>
          <span>__________________________</span>
          <p>Signature</p>
        </div>
        <h5 className="adtiya_headings">Schedule – 1</h5>
        <h5 className="adtiya_headings">Fees Sharing</h5>
        <div style={{ display: "flex" }}>
          <Image
            style={{ width: "50%", height: 250 }}
            src={`/images/Aditya_table.png`}
            alt=""
          ></Image>
        </div>
        <h5 className="adtiya_headings">Note</h5>
        <ul>
          <li style={{ margin: 15 }}>
            Above POP fees sharing of charges is subject to regulatory
            notification from time to time.
          </li>
          <li style={{ margin: 15 }}>All charges are excluding GST</li>
          <li style={{ margin: 15 }}>
            Fees payout shall be in the form of marketing expenses and it will
            paid by ABSLPML at the end of each quarter on the basis of an
            invoice raised by the Referral Agent.
          </li>
        </ul>
      </div>
    );
  }
}
